// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"arrow-link_arrowLink__CW6qT","left":"arrow-link_left__uZ_rn","right":"arrow-link_right__uesRG"};